import { i as m, x as o, r as f, n as d } from "./abstract-base-CdeHT0x1.js";
import { e as g } from "./class-map-Ckx5HLrM.js";
import { o as v } from "./unsafe-svg-BCSzTTw5.js";
import { B as u } from "./table-cell-eFwJxJGY.js";
import { p as y } from "./lifecycle-decorators-VlFt_asj.js";
import { c as w, a as x } from "./query-assigned-DiX8lRAH.js";
var i = /* @__PURE__ */ ((r) => (r.TEXT = "text", r.NUMERAL = "numeral", r.DATE = "date", r.ICONS = "icons", r))(i || {});
const D = `<svg role="img" aria-label="down" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11.5L3 4L13 4L8 11.5Z" fill="var(--beacon-system-color-icon-error, #DD3636)"/>
</svg>`, z = `<svg role="img" aria-label="up" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 4L13 11.5H3L8 4Z" fill="var(--beacon-system-color-icon-positive, #248647)"/>
</svg>`, N = m`:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-zero-value: 0;--table-record-inline-size-content: fit-content;--table-record-unset: unset;--table-record-numeral-gap: 0 var(--beacon-reference-space-4);--table-record-space-margin-inline-end-default: var(--beacon-reference-space-2);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-1)}@media (width >= 640px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-start-default: var(--beacon-reference-space-2)}}@media (width >= 960px){:root[beacon-tag-name=beacon-table-record],:root [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][class*=beacon-on] [beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[class*=beacon-on] [beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"][beacon-tag-name=beacon-table-record],[beacon-version="4.4.0"] [beacon-tag-name=beacon-table-record]{--table-record-space-margin-inline-end-default: var(--beacon-reference-space-4);--table-record-space-margin-inline-start-default: var(--beacon-reference-space-4)}}`, A = m`[beacon-tag-name=beacon-table-record][variant=text] :is(h1,h2,h3,h4,h5,h6){font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100)}[beacon-tag-name=beacon-table-record][variant=text] *{margin:0}[beacon-tag-name=beacon-table-record][variant=text]>*+*{margin-block-start:var(--record-text-content-space, var(--beacon-reference-space-5))}[beacon-tag-name=beacon-table-record][variant=text] :last-child{--record-text-content-space: var(--beacon-reference-space-3)}[beacon-tag-name=beacon-table-record] p{margin:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]{padding:0}[beacon-tag-name=beacon-table-record] [beacon-tag-name=beacon-icon-button]:not(:last-child){margin-inline-end:var(--beacon-reference-space-2)}`, C = m`:host{color:var(--beacon-system-color-text-standard);inline-size:inherit;word-break:initial}.has-cell-padding{padding-block:0;padding-inline:0}.record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default);display:flex;gap:var(--beacon-reference-space-5);margin-inline:0}:host([variant=numeral]) .record-cell-wrapper,:host([variant=date]) .record-cell-wrapper,:host([variant=icons]) .record-cell-wrapper{--margin-end: var(--table-record-space-margin-inline-end-default);--margin-start: var(--table-record-space-margin-inline-start-default)}:host([sorting][variant=numeral]) .record-cell-wrapper,:host([sorting][variant=date]) .record-cell-wrapper,:host([sorting][variant=icons]) .record-cell-wrapper{--margin-end: var(--beacon-reference-space-7)}.record-numeral{align-items:flex-end;display:flex;flex-wrap:wrap;gap:var(--table-record-numeral-gap);justify-content:end;margin-block-end:0}.no-content{color:var(--beacon-system-color-text-inactive)}.record-na{color:var(--beacon-system-color-text-standard)}.record-cell{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);flex-grow:1;margin-block-start:0}.record-cell:is(.numeral,.date){display:grid;gap:var(--beacon-reference-space-1);text-align:end}.record-cell.icons{align-items:center;display:flex;justify-content:end}.record-cell.bold .record-na,.record-cell.sorted .record-na{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-100)}.record-delta{align-items:center;display:flex;gap:var(--beacon-reference-space-1)}.record-delta-value{color:var(--beacon-system-color-text-standard)}.record-delta-icon{block-size:var(--beacon-reference-space-5);display:inline-block;inline-size:var(--beacon-reference-space-5)}.record-footnote{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-caption-200);color:var(--beacon-system-color-text-standard);margin:0}.empty{display:none}.action-zone:not(.empty){display:var(--table-record-zero-value, grid);grid-template-rows:0;inline-size:var(--table-record-inline-size-content);margin-block-start:0;place-items:center}.hide{display:none}`;
var S = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, a = (r, t, s, l) => {
  for (var n = l > 1 ? void 0 : l ? $(t, s) : t, b = r.length - 1, p; b >= 0; b--)
    (p = r[b]) && (n = (l ? p(t, s, n) : p(n)) || n);
  return l && n && S(t, s, n), n;
};
const h = "beacon-table-record", B = o`&#8212`;
var c;
const e = (c = class extends u {
  constructor() {
    super(...arguments), this.beaconTagName = h, this.variant = i.TEXT, this.sorted = !1, this.hasActionZoneContent = !1;
  }
  static get styles() {
    return [super.styles, C];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, A, N];
  }
  /**
   * Returns sign of delta to determine delta icon styles
   *
   * @returns true/false for positive/negative respectively
   */
  get deltaPositive() {
    return this.slottedDelta > 0;
  }
  setActionZoneStatus() {
    this.hasActionZoneContent = this.actionZone.length > 0;
  }
  deltaSlotChange() {
    let t;
    this.slottedDeltaNodes.length > 0 && (t = this.slottedDeltaNodes.map((s) => {
      var l, n;
      return (n = (l = s.textContent) == null ? void 0 : l.trim()) != null ? n : "";
    }).join("")), t && (this.slottedDelta = parseFloat(t));
  }
  /**
   * Renders slot element with default styles
   * @returns default empty slot styles
   */
  static renderSlot() {
    return o`<span class="record-na"
      ><slot><span class="no-content">${B}</span></slot></span
    >`;
  }
  /**
   * Renders numeral and delta with proper spacing
   * @returns HTML template for numeral element in numeral record
   */
  renderNumeral() {
    const t = this.slottedDelta && !this.hideDeltaIcon ? o`<span class="record-delta-icon">
            ${this.deltaPositive ? v(z) : v(D)}
          </span>` : o``, s = {
      "record-delta-value": !0,
      hide: !this.slottedDelta || this.hideDeltaValue
    };
    return o` <span class="record-delta"> ${t}<span class=${g(s)}><slot name="delta" @slotchange=${this.deltaSlotChange}></span></slot></span>${c.renderSlot()}`;
  }
  /**
   * Conditionally renders cell contents
   * @returns HTML template according to variant type
   */
  renderCell() {
    switch (this.variant) {
      case i.NUMERAL:
        return o`<div class="record-numeral">${this.renderNumeral()}</div>
          <p class="record-footnote"><slot name="footnote"></slot></p>`;
      case i.DATE:
      case i.TEXT:
      case i.ICONS:
      default:
        return c.renderSlot();
    }
  }
  /**
   * Default render function
   * @returns HTML template for table record component
   */
  render() {
    return o`<div class="record-cell-wrapper" part="cell-wrapper">
      <div
        class="has-cell-padding record-cell ${this.bold ? "bold" : ""} ${this.sorted ? "sorted" : ""} ${this.variant}"
        part="cell">
        ${this.renderCell()}
      </div>
      ${this.variant === i.NUMERAL ? o`<div
            class="action-zone ${g({
      empty: !this.hasActionZoneContent
    })}"
            part="action-zone">
            <slot name="action-zone"></slot>
          </div>` : o``}
    </div>`;
  }
}, c.tagName = h, c);
a([
  d({ reflect: !0 })
], e.prototype, "variant", 2);
a([
  f()
], e.prototype, "slottedDelta", 2);
a([
  w({ flatten: !0, slot: "delta" })
], e.prototype, "slottedDeltaNodes", 2);
a([
  d({ attribute: "sort-value", reflect: !0 })
], e.prototype, "sortValue", 2);
a([
  d({ type: Boolean, reflect: !0 })
], e.prototype, "bold", 2);
a([
  d({ type: Boolean, reflect: !0 })
], e.prototype, "sorted", 2);
a([
  d({ type: Boolean, reflect: !0, attribute: "hide-delta-icon" })
], e.prototype, "hideDeltaIcon", 2);
a([
  d({
    type: Boolean,
    reflect: !0,
    attribute: "hide-delta-value"
  })
], e.prototype, "hideDeltaValue", 2);
a([
  f()
], e.prototype, "hasActionZoneContent", 2);
a([
  x({ slot: "action-zone" })
], e.prototype, "actionZone", 2);
a([
  y
], e.prototype, "setActionZoneStatus", 1);
let P = e;
export {
  P as B,
  i as T
};
